const DISPLAY_NAMES: Record<string, string> = {
  _system_explore: 'Explore',
  _system_research: 'Research',
  _system_plan: 'Plan',
  _system_evaluate: 'Evaluate',
  _system_audit: 'Audit',
  _system_triage: 'Triage',
  _system_explore_results: 'Explore Results',
};

export function formatPersonaName(name: string): string {
  if (DISPLAY_NAMES[name]) return DISPLAY_NAMES[name];
  if (name.startsWith('_system_')) {
    return name
      .replace(/^_system_/, '')
      .split('_')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }
  return name;
}

export function formatPersonaLabel(name: string, taskId?: string): string {
  const display = formatPersonaName(name);
  if (taskId) {
    return `${display} #${taskId.slice(0, 4)}`;
  }
  return display;
}
